<template>
	<div>
		<div class="pro_c_item_m">
			<h2>
				{{ contentData.bdTitlecn }}
			</h2>
			<div>
				<div v-html="contentData.bdContentcn" class="detail"></div>
			</div>
		</div>

		<div class="pro_c_item">
			<h2>
				{{ contentData.bdTitlecn }}
			</h2>
			<div v-html="contentData.bdContentcn"></div>
		</div>
	</div>
</template>

<script>
import Axios from 'axios'
const Base64 = require('js-base64')

export default {
	data() {
		return {
			contentData: {},
			paramsId: '',
			p_data: [],
		}
	},
	watch: {
		$route() {
			this.paramsId = this.$route.params.id
		},
		paramsId() {
			this.init()
		},
	},

	mounted() {
		this.init()
	},

	methods: {
		goDetail() {
		},
		P_detail(item) {
			this.$router.push('/solution/profile/' + item.bd_atpid)
		},
		async init() {
			let axios1 = await Axios({
				url:'/apiv2/bdoc/getone?bdAtpid='+this.$route.params.id,
			}).then((res) => {
				this.contentData=res.data.data
				this.contentData.bdContentcn=Base64.decode(this.contentData.bdContentcn).replaceAll("<a","<a rel='noopener noreferrer'")
			})
			let axios2 = ''
			Promise.all([axios1, axios2])
		},
	},
}
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	@import './index.scss';
}
::v-deep font{
	line-height: 40px;
}
::v-deep span{
	line-height: 40px;
}
::v-deep p{
	line-height: 40px;
}
::v-deep .detail{
	padding-left:5%;
	padding-right:5%;
	p{
		text-align: left;
	}
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m-index.scss';
}
</style>